import React from 'react'
import hoistNonReactStatics from 'hoist-non-react-statics'

const forwardInnerRef = Component => {
  const withRefComp = React.forwardRef((props, ref) => {
    return <Component {...props} innerRef={ref} />
  })

  hoistNonReactStatics(withRefComp, Component)
  return withRefComp
}

export default forwardInnerRef
